/**
 * Fallback public URLs when the deployment only sets `APP_ENVIRONMENT` (and
 * optional overrides in `/runtime-env.js`). Values mirror the repo `.env.*`
 * files for each environment name.
 *
 * Pod env / `window.__RUNTIME_CONFIG__` always wins when a key is non-empty.
 */
export type PublicEnvKey = 'PNC_UI_APP_URL' | 'PNC_UI_WIDGET_URL' | 'PNC_UI_API_URL_API_GATEWAY';

export type PublicEnvDefaults = Partial<Record<PublicEnvKey, string>>;

export const PUBLIC_ENV_DEFAULTS_BY_APP_ENVIRONMENT: Record<string, PublicEnvDefaults> = {
  'pti-shared': {
    PNC_UI_APP_URL: 'https://shared-pnc-ui.pti-dev.cloud',
    PNC_UI_API_URL_API_GATEWAY: 'https://shared-api.pti-dev.cloud',
    PNC_UI_WIDGET_URL: 'https://shared-novapay-ui.pti-dev.cloud/forte-payments-widget.js'
  },
  'pti-staging': {
    PNC_UI_APP_URL: 'https://staging-pnc-ui.pti-dev.cloud',
    PNC_UI_API_URL_API_GATEWAY: 'https://staging-api.pti-dev.cloud',
    PNC_UI_WIDGET_URL: 'https://dev-forte-payments-cdn.pti-dev.cloud/forte-payments-widget.js'
  },
  'pti-prod': {
    PNC_UI_APP_URL: 'https://payments.forte.io',
    PNC_UI_API_URL_API_GATEWAY: 'https://prod-api.pti-prod.cloud',
    PNC_UI_WIDGET_URL: 'https://client.payments.forte.io/forte-payments-widget.js'
  },
  'pti-demo': {
    PNC_UI_APP_URL: 'https://demo-pnc-ui.pti-prod.cloud',
    PNC_UI_API_URL_API_GATEWAY: 'https://demo-api.pti-prod.cloud',
    PNC_UI_WIDGET_URL: 'https://demo-forte-payments-cdn.pti-prod.cloud/forte-payments-widget.js'
  },
  'lemmax-staging': {
    PNC_UI_API_URL_API_GATEWAY: 'https://staging-api.dev.lemmax.com',
    PNC_UI_WIDGET_URL: 'https://staging-novapay-ui.dev.lemmax.com/forte-payments-widget.js'
  },
  'lemmax-showcase': {
    PNC_UI_API_URL_API_GATEWAY: 'https://showcase-api.dev.lemmax.com',
    PNC_UI_WIDGET_URL: 'https://dev-forte-payments-cdn.dev.lemmax.com/forte-payments-widget.js'
  },
  'lemmax-shared': {
    PNC_UI_API_URL_API_GATEWAY: 'https://shared-api.dev.lemmax.com',
    PNC_UI_WIDGET_URL: 'https://shared-novapay-ui.dev.lemmax.com/forte-payments-widget.js'
  },
  'lemmax-sandbox': {
    PNC_UI_API_URL_API_GATEWAY: 'https://sandbox-api.sandbox.lemmax.com',
    PNC_UI_WIDGET_URL: 'https://payments.sandbox.lemmax.com/forte-payments-widget.js'
  },
  'lemmax-qa': {
    PNC_UI_API_URL_API_GATEWAY: 'https://qa-api.dev.lemmax.com',
    PNC_UI_WIDGET_URL: 'https://qa-novapay-ui.dev.lemmax.com/forte-payments-widget.js'
  },
  'lemmax-prod': {
    PNC_UI_API_URL_API_GATEWAY: 'https://api.prod.lemmax.com',
    PNC_UI_WIDGET_URL: 'https://payments.prod.lemmax.com/forte-payments-widget.js'
  }
};
